import { render, staticRenderFns } from "./NotificationTemplateItem.vue?vue&type=template&id=673f445e&scoped=true"
import script from "./NotificationTemplateItem.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateItem.vue?vue&type=style&index=0&id=673f445e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f445e",
  null
  
)

export default component.exports